<template>
  <div>
    <div class="container">
      <el-form label-position="right" label-width="100px" size="mini">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input class="input-width" placeholder="请输入订单号" v-model="params.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="外卖号/叫号">
              <el-input class="input-width" placeholder="请输入外卖号或叫号" v-model="params.daynumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="桌号">
              <el-input class="input-width" placeholder="请输入桌号号" v-model="params.desk"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单类型">
              <el-select v-model="params.deliverkind" placeholder="请选择订单类型">
                <el-option v-for="item in deliverkinds" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否分销">
              <el-select v-model="params.isprofitsharing" placeholder="请选择订单类型">
                <el-option label="全部" :value="0"> </el-option>
                <el-option label="非分销" :value="1"> </el-option>
                <el-option label="分销单" :value="2"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="下单人手机号">
              <el-input class="input-width" placeholder="请输入下单人手机号" v-model="params.useridormobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="下单时间">
              <el-date-picker :picker-options="pickerOptions" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" type="daterange" unlink-panels v-model="params.time"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="operation-btns">
        <el-button @click="onClickFilter" size="small">筛选</el-button>
        <el-button @click="onClickClearFilter" style="color:#4E759E;" size="small" type="text">清空筛选条件</el-button>
      </div>
    </div>

    <div class="container">
      <comp-tab :data="tabs" v-model="params.status" />
    </div>

    <div class="container">
      <div class="product-card" v-for="item in list" :key="item.id">
        <div class="product-card-head">
          <span class="product-id">{{ item.id }}</span>
          <span class="product-need-voice" v-show="item.needinvoice == 1">需要开发票</span>
          <div class="product-other-info">
            <el-button @click="$router.push({ name: 'order-detail', query: { id: item.id } })" size="small" type="text">
              查看详情
            </el-button>
          </div>
        </div>
        <table class="product-card-table">
          <tr>
            <td width="100px">
              <span
                class="product-deliver-type"
                :style="{
                  backgroundColor: getProductDeliverTypeColor(item.deliverkind)
                }"
              >
                {{ getProductDeliverType(item.deliverkind) }} </span
              ><br />
              <span v-if="item.deliverkind == 1" class="product-deliver-time">{{ new Date(item.delivertime * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }} </span><br />
              <span v-if="item.deliverkind == 1 && item.delivertime < parseInt(Date.now() / 1000) && item.status == 3" class="product-out-time">已超时</span>
              <span v-if="item.deliverkind == 2" class="product-deliver-time">#{{ item.daynumber }} </span>
              <span v-if="item.deliverkind == 3" class="product-deliver-time">#{{ item.desk }} </span>
              <span v-if="item.deliverkind == 4" class="product-deliver-time">#{{ item.daynumber }} </span>
            </td>
            <td width="240px" style="text-align: left; vertical-align: top;">
              <span v-for="oproduct of item.orderproductsList" :key="oproduct.productid"> {{ oproduct.product.name }} {{ oproduct.optionname && '(' + Object.values(JSON.parse(oproduct.optionname)).join(', ') + ')' }} × {{ oproduct.quantity }}<br /></span>
            </td>
            <td width="80px">
              {{ item.user.nickname }}<br />
              {{ item.user.mobile }}<br />
              <span class="product-member-tag" v-if="item.user.isvip === 2">会员</span>
            </td>
            <td width="80px">
              {{ new Date(item.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}
            </td>
            <td width="80px">￥{{ (item.actualamount + item.freight) / 1000 }}</td>
            <td style="text-align: left; vertical-align: top;">
              {{ item.note }}
            </td>
            <td width="100px">
              {{ getOrderStatus(item.status, item.deliverkind) }}
              <tr />
              <template v-if="item.status === 12">
                <el-button size="small" type="text" @click="() => update(item, 8)">
                  退款
                </el-button>
                <el-button size="small" type="text" @click="() => update(item, 2)">
                  拒绝
                </el-button>
              </template>
              <template v-if="item.status === 2">
                <el-button size="small" type="text" @click="() => update(item, 8)">
                  退款
                </el-button>
                <el-button size="small" type="text" @click="() => update(item, 3)">
                  确认接单
                </el-button>
              </template>
            </td>
          </tr>
        </table>
      </div>
      <div v-if="!list.length" class="list-nodata">
        <div>暂无数据</div>
      </div>

      <div v-if="list.length" class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getOrders" size="small" type="primary">加载更多</el-button>
        <p v-else style="color: #ccc; font-size: 12px;">已加载全部，没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

const pickerOptions = {
  shortcuts: [
    {
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }
  ]
};
const deliverkinds = [
  {
    value: 0,
    label: '所有订单'
  },
  {
    value: '3',
    label: '桌号堂食'
  },
  {
    value: '4',
    label: '叫号堂食'
  },
  {
    value: '1',
    label: '自提'
  },
  {
    value: '2',
    label: '外卖'
  }
];
const orderStatus = {
  '0': '等待顾客支付',
  '2_1': '等待商家备货',
  '2_2': '等待商家发货',
  '2_3': '等待商家上菜',
  '2_4': '等待商家备菜',
  '3_1': '等待顾客取货',
  '3_2': '已接单待收货',
  '3_3': '已接单待收货',
  '3_4': '已接单待收货',
  '4': '已完成',
  '6': '顾客已取消订单',
  '8': '已退款',
  '12': '顾客请求退款'
};
// kind 7: 0未支付, 2待发货, 3待收货, 4已收货, 6已取消, 8已退款, 12待发货申请退款
// 1 自取 2 配送 3 桌号堂食 4 叫号堂食
const getOrderStatus = (status, deliverkind) => orderStatus[status] || orderStatus[`${status}_${deliverkind}`];

export default {
  components: {
    'comp-tab': tab
  },
  name: 'order-list',
  watch: {
    'params.status': function() {
      this.list = [];
      this.getOrders();
    }
  },
  data() {
    return {
      tabs: [{ label: '全部订单', value: -1 }, { label: '待退款', value: 12 }, { label: '已退款', value: 8 }],
      pickerOptions,
      deliverkinds,
      list: [],
      params: {
        id: '',
        status: -1,
        statuslistList: [12, 8],
        idlessthan: 0,
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        sortby: 1,
        sort: 1,
        deliverkind: 0,
        desk: '',
        daynumber: '',
        count: 20,
        delivermobile: '',
        isprofitsharing: 0,
        time: []
      },
      loadmore: false,
      hasMore: true
    };
  },
  created() {
    this.token = getToken();
    this.getOrders();
  },
  methods: {
    // 订单列表
    async getOrders() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.createdatgreaterthan = 0;
      this.params.createdatlessthan = 0;
      if (this.params.time.length === 2) {
        this.params.createdatgreaterthan = parseInt(this.params.time[0].getTime() / 1000);
        this.params.createdatlessthan = parseInt(this.params.time[1].getTime() / 1000);
      }
      // 根据手机号获取用户id
      if (this.params.delivermobile) {
        const res = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.delivermobile,
            count: 1,
            order: 0
          })
        );
        this.params.userid = res.userlistList.length ? res.userlistList[0].id : 0;
      }
      // 获取订单列表
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreOrderService.GetOrderList',
        M('OrderListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      if (res.orderlistList.length === 0) {
        this.loadmore = false;
        this.hasMore = false;
        return;
      }
      // 完善订单列表里的关联资源
      const useridlist = res.orderlistList.map(item => item.userid);
      const productidlist = [];
      res.orderlistList.forEach(item => {
        item.orderproductsList.forEach(item1 => {
          productidlist.push(item1.productid);
        });
      });
      const reslist = await Promise.all([
        rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: useridlist,
            count: useridlist.length,
            order: 0
          })
        ),
        rpc(
          'StoreProductService.GetProductList',
          M('ProductListQueryRequest', {
            token: M('Token', { token: this.token }),
            idlistList: productidlist,
            sortby: 1,
            sort: 1,
            count: productidlist.length
          })
        )
      ]);
      res.orderlistList.forEach(item => {
        item.user = reslist[0].userlistList.find(v => v.id === item.userid);
        item.orderproductsList.forEach(item1 => {
          item1.product = reslist[1].productlistList.find(v => v.id === item1.productid);
        });
      });
      this.list = this.list.concat(res.orderlistList);
      this.hasMore = res.orderlistList.length;
      this.loadmore = false;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
    },

    onClickFilter() {
      this.list = [];
      this.getOrders();
    },
    onClickClearFilter() {
      this.params = {
        id: '',
        status: -1,
        statuslistList: null,
        idlessthan: 0,
        createdatgreaterthan: 0,
        createdatlessthan: 0,
        sortby: 1,
        sort: 1,
        deliverkind: 0,
        desk: '',
        daynumber: '',
        count: 20,
        delivermobile: '',
        time: []
      };
      this.list = [];
      this.getOrders();
    },
    getProductDeliverType(deliverkind) {
      // 1 自取 2 配送 3 桌号堂食 4 叫号堂食
      if (deliverkind === 1) return '自提';
      if (deliverkind === 2) return '外卖';
      if (deliverkind === 3) return '桌号堂食';
      if (deliverkind === 4) return '叫号堂食';
      return '';
    },
    getProductDeliverTypeColor(deliverkind) {
      // 1 自取 2 配送 3 桌号堂食 4 叫号堂食
      if (deliverkind === 1) return '#549f44';
      if (deliverkind === 2) return '#559cda';
      if (deliverkind === 3 || deliverkind === 4) return '#cd4a58';
      return '';
    },
    getOrderStatus,
    update(row, status) {
      row.status = status;
      rpc(
        'StoreOrderService.UpdateOrder',
        M('OrderWithTokenRequest', {
          token: M('Token', { token: this.token }),
          order: M('Order', {
            ...row,
            address: M('Address', row.address),
            invoice: M('Invoice', row.invoice),
            orderproductsList: row.orderproductsList.map(v => M('OrderProduct', v))
          })
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1, row);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.input-width {
  width: 170px;
}
.list-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  color: #999;
}
.list-tabs {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.operation-btns {
  text-align: right;
}
.product-card:not(:last-child) {
  margin-bottom: 10px;
}
.product-card-head {
  height: 42px;
  padding: 0 10px;
  line-height: 42px;
  font-size: 14px;
  background-color: #f8f8f8;
  color: #666;
  & > * {
    vertical-align: middle;
  }
  & > *:not(:first-child) {
    margin-left: 10px;
  }
}
.product-need-voice {
  display: inline-block;
  padding: 3px 6px;
  border-radius: 4px;
  line-height: 16px;
  background-color: #e9e9e9;
  color: #4ba3dd;
}
.product-member-tag {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 4px;
  line-height: 14px;
  font-size: 12px;
  background-color: #f0dcdc;
  color: #ff4f4f;
}
.product-other-info {
  float: right;
  & > *:not(:first-child) {
    margin-left: 10px;
  }
}
.product-deliver-type {
  display: inline-block;
  padding: 2px 4px;
  border-radius: 4px;
  line-height: 14px;
  font-size: 12px;
  color: #fff;
}
.product-card-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e9e9e9;
  td {
    height: 100px;
    padding: 10px;
    border: 1px solid #e9e9e9;
    line-height: 20px;
    text-align: center;
  }
}
.product-out-time {
  color: #ff4f4f;
}
</style>
